import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SmsTemplete } from './components';

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/SmsTemplate"
    component={SmsTemplete}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsTemplete/routes.js